import { ReportFlowStep } from '../../../../types/dtos/reports.dto';
import { ReportExportFormat, ReportSteps, ReportType } from '../../../../types/enums/report.enum';
import { StepperStepInterface } from '../../../../types/interfaces/stepper.interface';

const selectFormatStep = (): ReportFlowStep => ({
  step: ReportSteps.SELECT_FORMAT,

  next: [
    {
      when: (ctx) =>
        ctx.format === ReportExportFormat.CSV,

      step: ReportSteps.SELECT_COLUMNS,

      next: [
        {
          step: ReportSteps.DOWNLOAD_REPORT,
        },
      ],
    },

    {
      when: (ctx) =>
        ctx.format === ReportExportFormat.PDF,

      step: ReportSteps.DOWNLOAD_REPORT,
    },
  ],
});

export const reportConfig: ReportFlowStep[] = [
  {
    step: ReportSteps.SELECT_REPORT_TYPE,

    next: [
      {
        when: (ctx) =>
          ctx.reportType === ReportType.DEVICE,

        step: ReportSteps.FILTER_ELEMENTS,

        next: [
          selectFormatStep(),
        ],
      },

      {
        when: (ctx) =>
          ctx.reportType === ReportType.DEVICE_DETAIL,

        step: ReportSteps.SELECT_TIME,

        next: [
          {
            step: ReportSteps.SELECT_ELEMENTS,

            next: [
              {
                step: ReportSteps.DOWNLOAD_REPORT,
              },
            ],
          },
        ],
      },

      {
        when: (ctx) =>
          ctx.reportType === ReportType.ALARM,

        step: ReportSteps.SELECT_TIME,

        next: [
          {
            step: ReportSteps.FILTER_ELEMENTS,

            next: [
              selectFormatStep(),
            ],
          },
        ],
      },

      {
        when: (ctx) =>
          ctx.reportType === ReportType.MEASUREMENT,

        step: ReportSteps.SELECT_TIME,

        next: [
          {
            step: ReportSteps.FILTER_ELEMENTS,

            next: [
              {
                step: ReportSteps.SELECT_FORMAT,

                next: [
                  {
                    when: (ctx) =>
                      ctx.format === ReportExportFormat.CSV,

                    step: ReportSteps.DOWNLOAD_REPORT,
                  },
                  {
                    when: (ctx) =>
                      ctx.format === ReportExportFormat.PDF,

                    step: ReportSteps.DOWNLOAD_REPORT,
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        when: (ctx) =>
          ctx.reportType === ReportType.LOG,

        step: ReportSteps.SELECT_TIME,

        next: [
          {
            step: ReportSteps.FILTER_ELEMENTS,

            next: [
              selectFormatStep(),
            ],
          },
        ],
      },

      {
        when: (ctx) =>
          ctx.reportType === ReportType.SIGI,

        step: ReportSteps.DOWNLOAD_REPORT,
      },
    ],
  },
];


export const REPORT_STEP_DEFINITIONS: Record<ReportSteps, StepperStepInterface> = {

  [ReportSteps.SELECT_REPORT_TYPE]: {
    value: ReportSteps.SELECT_REPORT_TYPE,
    isTranslated: true,
    label: 'common.fields.report-type',
    iconName: 'description',
  },

  [ReportSteps.SELECT_TIME]: {
    value: ReportSteps.SELECT_TIME,
    isTranslated: true,
    label: 'common.fields.date-range',
    iconName: 'date_range',
  },

  [ReportSteps.SELECT_ELEMENTS]: {
    value: ReportSteps.SELECT_ELEMENTS,
    isTranslated: true,
    label: 'common.fields.elements',
    iconName: 'filter_alt',
  },

  [ReportSteps.FILTER_ELEMENTS]: {
    value: ReportSteps.FILTER_ELEMENTS,
    isTranslated: true,
    label: 'common.fields.filter',
    iconName: 'filter_alt',
  },

  [ReportSteps.SELECT_FORMAT]: {
    value: ReportSteps.SELECT_FORMAT,
    isTranslated: true,
    label: 'common.fields.format',
    iconName: 'edit_document',
  },

  [ReportSteps.SELECT_COLUMNS]: {
    value: ReportSteps.SELECT_COLUMNS,
    isTranslated: true,
    label: 'common.fields.columns',
    iconName: 'table_chart',
  },

  [ReportSteps.DOWNLOAD_REPORT]: {
    value: ReportSteps.DOWNLOAD_REPORT,
    isTranslated: true,
    label: 'common.fields.download',
    iconName: 'download',
  },
};
